
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
    props: {
        value: {
            type: [Number, String],
            required: true,
        },
        postfix: {
            type: String,
            default: '',
        },
        textClass: {
            type: undefined,
        },
    },
    computed: {
        sign() {
            const value = Number(this.value);
            if (value < 0) {
                return '-';
            }
            if (value > 0) {
                return '+';
            }
            return '';
        },
        moduledValue() {
            const value = Number(this.value);
            return value >= 0 ? value : value * (-1);
        },
    },
});
